import React from 'react';
import { Link } from 'react-router-dom';

const TradingPlatforms = () => {
  return (
    <div className="container py-5">
      <div className="row">
        <div className="col-lg-8 mx-auto">
          <h1 className="mb-4">💻 Trading Platforms Comparison</h1>
          <p className="lead mb-5">
            A comprehensive guide to help you choose the right trading platform for your investment journey
          </p>
          
          <div className="card mb-4">
            <div className="card-body">
              <h3>Robinhood</h3>
              <div className="row">
                <div className="col-md-4">
                  <div className="text-center mb-3">
                    <img 
                      src="https://play-lh.googleusercontent.com/Pk3xrfqKlUb9qZHQqYDrxPm9UQo9uLkKh3qmZz0wuRMnlNYmRvvEI_MUYfuK_NYKpw" 
                      alt="Robinhood Logo" 
                      className="img-fluid" 
                      style={{ maxHeight: '100px' }}
                    />
                  </div>
                </div>
                <div className="col-md-8">
                  <p>
                    Robinhood is a commission-free investing platform that allows users to trade stocks, ETFs, options, 
                    and cryptocurrencies with no account minimums.
                  </p>
                </div>
              </div>
              
              <div className="row mt-3">
                <div className="col-md-6">
                  <h5 className="text-success">Pros</h5>
                  <ul>
                    <li>Commission-free trades on stocks, ETFs, options, and cryptocurrencies</li>
                    <li>User-friendly mobile and web interface, ideal for beginners</li>
                    <li>No account minimums to get started</li>
                    <li>Fractional shares available (invest with as little as $1)</li>
                    <li>Cash management features with competitive interest rates</li>
                    <li>Instant deposit functionality</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h5 className="text-danger">Cons</h5>
                  <ul>
                    <li>Limited research and educational tools compared to traditional brokers</li>
                    <li>No access to mutual funds, bonds, or retirement accounts</li>
                    <li>Basic charting capabilities</li>
                    <li>Limited customer service options</li>
                    <li>Controversial payment for order flow business model</li>
                    <li>No tax-loss harvesting features</li>
                  </ul>
                </div>
              </div>
              
              <div className="mt-3">
                <h5>Best For</h5>
                <p>
                  Beginners, mobile-first traders, cryptocurrency enthusiasts, and investors looking for a 
                  simple, commission-free trading experience with low barriers to entry.
                </p>
              </div>
            </div>
          </div>
          
          <div className="card mb-4">
            <div className="card-body">
              <h3>Charles Schwab</h3>
              <div className="row">
                <div className="col-md-4">
                  <div className="text-center mb-3">
                    <img 
                      src="https://content.schwab.com/web/retail/public/about-schwab/schwab_logo_blue.png" 
                      alt="Charles Schwab Logo" 
                      className="img-fluid" 
                      style={{ maxHeight: '100px' }}
                    />
                  </div>
                </div>
                <div className="col-md-8">
                  <p>
                    Charles Schwab is a full-service brokerage offering a wide range of investment products, 
                    research tools, and educational resources for all types of investors.
                  </p>
                </div>
              </div>
              
              <div className="row mt-3">
                <div className="col-md-6">
                  <h5 className="text-success">Pros</h5>
                  <ul>
                    <li>Commission-free stock, ETF, and options trades</li>
                    <li>Comprehensive research and educational resources</li>
                    <li>Excellent customer service with 24/7 support</li>
                    <li>Full range of investment products (stocks, bonds, mutual funds, ETFs)</li>
                    <li>Robust retirement planning tools and accounts</li>
                    <li>Physical branch locations for in-person assistance</li>
                    <li>Advanced trading platforms for active traders (StreetSmart Edge)</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h5 className="text-danger">Cons</h5>
                  <ul>
                    <li>$0 minimum to open an account, but $1,000 for robo-advisor service</li>
                    <li>Higher options contract fees compared to some competitors</li>
                    <li>Steeper learning curve for beginners</li>
                    <li>Mobile app less intuitive than newer fintech competitors</li>
                    <li>Mutual fund transaction fees for non-Schwab funds</li>
                  </ul>
                </div>
              </div>
              
              <div className="mt-3">
                <h5>Best For</h5>
                <p>
                  Long-term investors, retirement savers, those who value research and educational resources, 
                  and investors who may occasionally need in-person assistance.
                </p>
              </div>
            </div>
          </div>
          
          <div className="card mb-4">
            <div className="card-body">
              <h3>Fidelity</h3>
              <div className="row">
                <div className="col-md-4">
                  <div className="text-center mb-3">
                    <img 
                      src="https://www.fidelity.com/bin-public/060_www_fidelity_com/images/Fidelity_Investments_Logo.png" 
                      alt="Fidelity Logo" 
                      className="img-fluid" 
                      style={{ maxHeight: '100px' }}
                    />
                  </div>
                </div>
                <div className="col-md-8">
                  <p>
                    Fidelity is a comprehensive brokerage offering a wide range of investment products, 
                    industry-leading research, and excellent customer service.
                  </p>
                </div>
              </div>
              
              <div className="row mt-3">
                <div className="col-md-6">
                  <h5 className="text-success">Pros</h5>
                  <ul>
                    <li>Commission-free stock, ETF, and options trades</li>
                    <li>Top-tier research and screening tools</li>
                    <li>Excellent trade execution quality</li>
                    <li>Strong retirement planning tools and services</li>
                    <li>Fractional share trading available</li>
                    <li>High-yield cash management account</li>
                    <li>Physical branch locations available</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h5 className="text-danger">Cons</h5>
                  <ul>
                    <li>Active Trader Pro platform less intuitive than some competitors</li>
                    <li>Mobile app can be overwhelming for beginners</li>
                    <li>Mutual fund transaction fees for non-Fidelity funds</li>
                    <li>Higher broker-assisted trade fees</li>
                    <li>Limited cryptocurrency options</li>
                  </ul>
                </div>
              </div>
              
              <div className="mt-3">
                <h5>Best For</h5>
                <p>
                  Retirement investors, research-focused traders, long-term investors, and those who value 
                  customer service and comprehensive educational resources.
                </p>
              </div>
            </div>
          </div>
          
          <div className="card mb-4">
            <div className="card-body">
              <h3>TD Ameritrade</h3>
              <div className="row">
                <div className="col-md-4">
                  <div className="text-center mb-3">
                    <img 
                      src="https://www.tdameritrade.com/content/dam/tda/retail/marketing/en/logos/TDA_Logo_Lock.svg" 
                      alt="TD Ameritrade Logo" 
                      className="img-fluid" 
                      style={{ maxHeight: '100px' }}
                    />
                  </div>
                </div>
                <div className="col-md-8">
                  <p>
                    TD Ameritrade offers a robust trading platform with advanced tools for active traders, 
                    while still catering to beginners with educational resources.
                  </p>
                </div>
              </div>
              
              <div className="row mt-3">
                <div className="col-md-6">
                  <h5 className="text-success">Pros</h5>
                  <ul>
                    <li>Commission-free stock, ETF, and options trades</li>
                    <li>Industry-leading trading platform (thinkorswim)</li>
                    <li>Extensive educational resources and paper trading</li>
                    <li>24/7 customer support</li>
                    <li>Wide range of investment products</li>
                    <li>No account minimums</li>
                    <li>Physical branch locations available</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h5 className="text-danger">Cons</h5>
                  <ul>
                    <li>Higher options contract fees than some competitors</li>
                    <li>Thinkorswim platform has steep learning curve</li>
                    <li>No fractional share trading</li>
                    <li>Being acquired by Charles Schwab (may lead to changes)</li>
                    <li>Mutual fund transaction fees for non-NTF funds</li>
                  </ul>
                </div>
              </div>
              
              <div className="mt-3">
                <h5>Best For</h5>
                <p>
                  Active traders, options traders, technical analysts, and investors who value educational 
                  resources and powerful trading tools.
                </p>
              </div>
            </div>
          </div>
          
          <div className="card mb-4">
            <div className="card-body">
              <h3>E*TRADE</h3>
              <div className="row">
                <div className="col-md-4">
                  <div className="text-center mb-3">
                    <img 
                      src="https://us.etrade.com/f/m/etx/static/images/etrade-logo.svg" 
                      alt="E*TRADE Logo" 
                      className="img-fluid" 
                      style={{ maxHeight: '100px' }}
                    />
                  </div>
                </div>
                <div className="col-md-8">
                  <p>
                    E*TRADE is a user-friendly platform that balances powerful trading tools with ease of use, 
                    making it suitable for both beginners and experienced investors.
                  </p>
                </div>
              </div>
              
              <div className="row mt-3">
                <div className="col-md-6">
                  <h5 className="text-success">Pros</h5>
                  <ul>
                    <li>Commission-free stock, ETF, and options trades</li>
                    <li>User-friendly web and mobile platforms</li>
                    <li>Power E*TRADE platform for active traders</li>
                    <li>Strong options trading tools and analytics</li>
                    <li>Extensive educational resources</li>
                    <li>Physical branch locations available</li>
                    <li>Robust retirement planning tools</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h5 className="text-danger">Cons</h5>
                  <ul>
                    <li>Higher options contract fees than some competitors</li>
                    <li>$500 minimum for Core Portfolios robo-advisor</li>
                    <li>Being acquired by Morgan Stanley (may lead to changes)</li>
                    <li>Mutual fund transaction fees for non-NTF funds</li>
                    <li>Limited cryptocurrency options</li>
                  </ul>
                </div>
              </div>
              
              <div className="mt-3">
                <h5>Best For</h5>
                <p>
                  Options traders, active stock traders, and investors who value a balance between 
                  user-friendly interfaces and advanced trading capabilities.
                </p>
              </div>
            </div>
          </div>
          
          <div className="card mb-4">
            <div className="card-body">
              <h3>Webull</h3>
              <div className="row">
                <div className="col-md-4">
                  <div className="text-center mb-3">
                    <img 
                      src="https://play-lh.googleusercontent.com/KCMTw5hQWw7XjOOTarjO9jjdVMQCgmqPbvwF_nGAuEkKMNTAPj1UKgf-aZmNgn_gEA" 
                      alt="Webull Logo" 
                      className="img-fluid" 
                      style={{ maxHeight: '100px' }}
                    />
                  </div>
                </div>
                <div className="col-md-8">
                  <p>
                    Webull is a commission-free trading platform that offers more advanced charting and 
                    analysis tools than many of its fintech competitors.
                  </p>
                </div>
              </div>
              
              <div className="row mt-3">
                <div className="col-md-6">
                  <h5 className="text-success">Pros</h5>
                  <ul>
                    <li>Commission-free trades on stocks, ETFs, options, and cryptocurrencies</li>
                    <li>No account minimums</li>
                    <li>Extended trading hours (4:00 AM to 8:00 PM ET)</li>
                    <li>Advanced charting capabilities and technical indicators</li>
                    <li>Free real-time market data</li>
                    <li>Paper trading functionality</li>
                    <li>Fractional share trading available</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h5 className="text-danger">Cons</h5>
                  <ul>
                    <li>Limited educational resources compared to traditional brokers</li>
                    <li>No access to mutual funds or bonds</li>
                    <li>Limited customer service options</li>
                    <li>No retirement accounts (IRAs)</li>
                    <li>Steeper learning curve than Robinhood</li>
                    <li>Limited research tools</li>
                  </ul>
                </div>
              </div>
              
              <div className="mt-3">
                <h5>Best For</h5>
                <p>
                  Intermediate traders who want commission-free trading with more advanced technical 
                  analysis tools than basic platforms offer.
                </p>
              </div>
            </div>
          </div>
          
          <div className="card mb-4">
            <div className="card-body">
              <h3>Interactive Brokers</h3>
              <div className="row">
                <div className="col-md-4">
                  <div className="text-center mb-3">
                    <img 
                      src="https://www.interactivebrokers.com/images/web/logos/ib-logo-dark.svg" 
                      alt="Interactive Brokers Logo" 
                      className="img-fluid" 
                      style={{ maxHeight: '100px' }}
                    />
                  </div>
                </div>
                <div className="col-md-8">
                  <p>
                    Interactive Brokers is a professional-grade trading platform offering global market access, 
                    advanced order types, and competitive pricing for active traders.
                  </p>
                </div>
              </div>
              
              <div className="row mt-3">
                <div className="col-md-6">
                  <h5 className="text-success">Pros</h5>
                  <ul>
                    <li>Access to global markets in 33 countries</li>
                    <li>Commission-free US stock and ETF trades</li>
                    <li>Advanced order types and algos</li>
                    <li>Low margin rates</li>
                    <li>Powerful Trader Workstation platform</li>
                    <li>Extensive research tools</li>
                    <li>Fractional share trading available</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h5 className="text-danger">Cons</h5>
                  <ul>
                    <li>Complex platforms with steep learning curve</li>
                    <li>$10/month account maintenance fee (waived if certain conditions met)</li>
                    <li>Less intuitive for beginners</li>
                    <li>Customer service has historically been a weak point</li>
                    <li>Inactivity fees may apply</li>
                  </ul>
                </div>
              </div>
              
              <div className="mt-3">
                <h5>Best For</h5>
                <p>
                  Professional traders, active investors, international traders, and those seeking 
                  the lowest margin rates and access to global markets.
                </p>
              </div>
            </div>
          </div>
          
          <div className="card">
            <div className="card-body">
              <h3>Key Factors to Consider When Choosing a Platform</h3>
              <div className="row mt-3">
                <div className="col-md-6">
                  <h5>For Beginners</h5>
                  <ul>
                    <li><strong>User Interface:</strong> Look for intuitive, easy-to-navigate platforms</li>
                    <li><strong>Educational Resources:</strong> Tutorials, articles, and videos to help you learn</li>
                    <li><strong>Customer Support:</strong> Responsive help when you have questions</li>
                    <li><strong>Account Minimums:</strong> Low or no minimums to get started</li>
                    <li><strong>Fractional Shares:</strong> Ability to buy partial shares with small amounts</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h5>For Advanced Traders</h5>
                  <ul>
                    <li><strong>Advanced Charting:</strong> Technical indicators and customizable charts</li>
                    <li><strong>Order Types:</strong> Variety of order types beyond market and limit</li>
                    <li><strong>Research Tools:</strong> Fundamental data, screeners, and analysis</li>
                    <li><strong>Execution Speed:</strong> Fast, reliable trade execution</li>
                    <li><strong>API Access:</strong> For algorithmic trading capabilities</li>
                  </ul>
                </div>
              </div>
              
              <div className="alert alert-info mt-3">
                <h5><i className="bi bi-info-circle"></i> Remember</h5>
                <p className="mb-0">
                  The best platform for you depends on your individual needs, investment style, and goals. 
                  Consider starting with a platform that aligns with your current knowledge level and trading 
                  frequency, then potentially upgrading as your skills and requirements evolve.
                </p>
              </div>
            </div>
          </div>

          <div className="text-center mt-4">
            <Link to="/glossary" className="btn btn-primary-custom">
              Back to Glossary
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradingPlatforms;
